let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("7KMx7")).then(() => parcelRequire('6IjZ5'));